module.exports = __webpack_public_path__ + "static/media/400Error.3eb95950.svg";